import React from 'react';
import { Modal } from 'react-bootstrap';
import postsuccess from '../../images/password-restored.svg';
import { Link } from 'react-router-dom';

const PublishedPost = (props) => {
  return (
    <Modal
      className="publshedpost-modal"
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton></Modal.Header>
      <Modal.Body>
        <div className="post-success-body">
          {props.events ? (
            props.editMode ? (
              <h2>Great! Your Event Has been Updated!</h2>
            ) : (
              <h2>Great! You have published {props.eventName} event!</h2>
            )
          ) : (
            <h2>Great! You have published your post.</h2>
          )}
          <div className="modal-image">
            <img src={postsuccess} alt="published post image" />
          </div>
          <div className="dashboard-btn">
            {props.events ? (
              props.editMode ? (
                <Link to="/dashboard" className="button">
                  Go to Dashboard
                </Link>
              ) : (
                <Link to="/event" className="button">
                  Go to Events
                </Link>
              )
            ) : (
              <Link to="/posts" className="button">
                Go to Posts
              </Link>
            )}
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default PublishedPost;
